import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowUpOutline = function SvgArrowUpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 3.21967C11.7626 2.92678 12.2374 2.92678 12.5303 3.21967L18.7803 9.46967C19.0732 9.76256 19.0732 10.2374 18.7803 10.5303C18.4874 10.8232 18.0126 10.8232 17.7197 10.5303L12.75 5.56066V20.25C12.75 20.6642 12.4142 21 12 21C11.5858 21 11.25 20.6642 11.25 20.25V5.56066L6.28033 10.5303C5.98744 10.8232 5.51256 10.8232 5.21967 10.5303C4.92678 10.2374 4.92678 9.76256 5.21967 9.46967L11.4697 3.21967Z"
  })));
};

export { SvgArrowUpOutline as ReactComponent };
//# sourceMappingURL=arrow-up-outline.svg.js.map
